<template>
  <el-tabs type="card">
    <el-tab-pane label="对接配置">
      <div>
        <el-empty description="当前没有对接配置哦" v-show="!isFlag" ref="ruleForm">
          <el-button type="text" @click="isFlag = true">立即创建</el-button>
        </el-empty>
        <el-form ref="form" :model="form" :rules="rules" label-width="150px" v-show="isFlag">

          <el-form-item label="对接状态">
            <el-input :value="handleDockingStat(form.dockingStat)" placeholder="请输入对接状态" disabled></el-input>
          </el-form-item>

          <el-form-item label="工程编号">
            <el-input v-model="form.programId" placeholder="请输入工程编号"></el-input>
          </el-form-item>

          <el-form-item label="工程名称">
            <el-input v-model="form.programName" placeholder="请输入工程名称"></el-input>
          </el-form-item>

          <el-form-item label="底图尺寸">
            <el-input v-model="form.pictureSize" placeholder="例如：1024,768"></el-input>
          </el-form-item>

          <el-form-item label="令牌">
            <el-input v-model="form.token" placeholder="请输入令牌"></el-input>
          </el-form-item>





          <el-form-item>
            <el-button type="primary" @click="submitForm">{{ form.pkGlodonId ? '修改' : '立即创建' }}</el-button>
            <el-button @click="open('send')" type="success"
              v-show="form.dockingStat !== 1 && form.dockingStat !== 2">开启对接</el-button>
            <el-button @click="open('end')" type="danger" v-show="form.dockingStat === 1">关闭对接</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-tab-pane>

    <!-- <el-tab-pane label="对接日志">
      <el-button type="primary" size="small" icon="el-icon-refresh-left" v-if="tableData.length > 0"
        @click="findDockingLog">刷新</el-button>
      <el-table :data="tableData" style="width: 100%" v-if="tableData.length > 0" v-loading="loading">
        <el-table-column prop="createTime" label="时间"> </el-table-column>
        <el-table-column prop="dockingLog" label="日志"> </el-table-column>
      </el-table>
      <el-empty description="无日志" v-else>

        <el-button type="primary" size="small" icon="el-icon-refresh-left" @click="findDockingLog">刷新</el-button>
      </el-empty>
    </el-tab-pane> -->
  </el-tabs>
</template>

<script>
import { findDockingByTaskId,
   addDockingByGLD, updateDockingByGLD, endDockingByGLD, sendDockingByGLD,  } from '@/api/docking/gld'

export default {
  data() {
    return {
      tableData: [],
      loading: false,
      isFlag: false,
      send: {},
      form: {},
      rules: {
        accountNumber: [{ required: true, message: '对接平台账号不能为空' }],
        password: [{ required: true, message: '对接平台密码不能为空' }],
        projectId: [{ required: true, message: '对接项目Id不能为空' }],
        deviceId: [{ required: true, message: '设备Id不能为空' }],
        // projectNumV: [{ required: true, message: '对接监测编号不能为空' }],
        // projectNumF: [{ required: true, message: '对接监测编号不能为空' }],
        // projectNumH: [{ required: true, message: '对接监测编号不能为空' }],
        // projectNumL: [{ required: true, message: '对接监测编号不能为空' }],
      },
    }
  },
  props: {
    pkTaskId: {
      type: Number,
    },
  },
  methods: {
    handleDockingStat(val) {
      if (val === 0) {
        return '未对接'
      } else if (val === 1) {
        return '对接中'
      } else if (val === 2) {
        return '对接完成'
      }
    },
    async findDockingByTaskIdFun() {
      const { data: res } = await findDockingByTaskId(this.pkTaskId)
      console.log('res', res.data[0])
      if (res.data.length === 0) {
        this.isFlag = false
        return
      }
      this.form = res.data[0]
      this.isFlag = true

    },
    async dockingByGLDFun() {
      const { data: res } = this.form.pkGlodonId ? await updateDockingByGLD(this.form) : await addDockingByGLD({fkTaskId:this.pkTaskId,...this.form})
      this.$message({
        message: res.message,
        type: res.code === 200 ? 'success' : 'error',
      })
      res.code === 200 ? this.findDockingByTaskIdFun() : null
    },
    async endDockingByGLDFun() {
      const { data: res } = await endDockingByGLD({ taskId: this.form.fkTaskId, glodonId: this.form.pkGlodonId })
      this.$message({
        message: res.message,
        type: res.code === 200 ? 'success' : 'error',
      })
      res.code === 200 ? this.findDockingByTaskIdFun() : null
    },
    async sendDockingByGLDFun() {
      const { data: res } = await sendDockingByGLD({ taskId: this.form.fkTaskId, glodonId: this.form.pkGlodonId })
      this.$message({
        message: res.message,
        type: res.code === 200 ? 'success' : 'error',
      })
    },
    submitForm() {
     
      this.dockingByGLDFun()
    },
    open(type) {
      const text = type === 'end' ? '是否关闭对接?' : '是否发送数据?'
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          type === 'end' ? this.endDockingByGLDFun() : this.sendDockingByGLDFun()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    // async findDockingLog() {
    //   this.loading = true
    //   const { data: res } = await findDockingLogByTaskId({ id: this.pkTaskId })

    //   console.log('res', res.data)

    //   this.tableData = res.data
    //   this.loading = false
    // },
  },
  created() {
    this.findDockingByTaskIdFun()
    // this.findDockingLog()
  },
  mounted() { },
}
</script>

<style scoped lang="scss"></style>
